import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from 'react-toastify'

import { getActivities, GetActivitiesResponse } from '@/services/get-activities'

import { useCompanies } from '../use-companies'

export const GET_ACTIVITIES_QUERY = ['activities']

export interface UseGetActivitiesProps {
  dateRange: {
    start: Date
    end: Date
  }
  page: number
}

function formatDate(date: Date) {
  return date.toISOString().split('T')[0]
}

export function useGetActivities({ dateRange, page }: UseGetActivitiesProps) {
  const { selectedCompany } = useCompanies()

  const start_date = formatDate(dateRange.start)
  const end_date = formatDate(dateRange.end)

  const query = useQuery<GetActivitiesResponse, Error>({
    queryKey: [
      ...GET_ACTIVITIES_QUERY,
      selectedCompany?.id,
      { start_date, end_date, page },
    ],
    queryFn: ({ signal }) =>
      getActivities({ start_date, end_date, page }, { signal }),
  })

  useEffect(() => {
    if (!query.isFetching && query.error) {
      toast.error(
        `Não foi possível carregar as informações, tente novamente. [${query.error?.message}]`,
        {
          icon: <ErrorOutline />,
        },
      )
    }
  }, [query.error, query.isFetching])

  return query
}
